import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Container from '@components/ui/Container/Container'
import Media from '@components/ui/Media/Media'

import { findRichTextLink } from '@lib/findRichTextLink'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import { FC } from 'react'
import styles from './ImageTextStacked.module.scss'

type ImageTextStackedProps = {
  textAbove?: string
  image?: MediaWithCropsFragment
  textBelow?: string
  containerColor?: string
  textColor?: string
  horizontal?: boolean
}
const ImageTextStacked: FC<ImageTextStackedProps> = ({
  textAbove,
  image,
  textBelow,
  containerColor,
  textColor,
  horizontal,
}) => {
  return (
    <Container backgroundColor={containerColor} color={textColor} fluid>
      <div
        className={`${styles.container} ${
          horizontal ? styles.horizontal : styles.vertical
        }`}
      >
        <div className={styles.innerContainer}>
          <div className={image && styles.table}>
            <TrustedHtml
              className={styles.richText}
              html={textAbove == '' ? '&nbsp;' : textAbove}
            />
          </div>

          {image && (
            <Link
              link={
                findRichTextLink(textAbove) && findRichTextLink(textBelow)
                  ? null
                  : findRichTextLink(textAbove) || findRichTextLink(textBelow)
              }
              className={styles.table}
            >
              <div className={styles.imageContainer}>
                {horizontal ? (
                  <Media mediaWithCrops={image} />
                ) : (
                  <Media
                    mediaWithCrops={image}
                    style={{ aspectRatio: 4 / 5 }}
                  />
                )}
              </div>
            </Link>
          )}
          <div className={image && styles.table}>
            <TrustedHtml
              className={`${styles.richText} ${styles.eighty}`}
              html={textBelow == '' ? '&nbsp;' : textBelow}
            />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default ImageTextStacked
